import React from "react";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { esES } from "@mui/x-date-pickers/locales";
import "dayjs/locale/es";
import { useLanguage } from "context/LanguageProvider";

const SPANISH_LOCALE_TEXT = esES.components.MuiLocalizationProvider.defaultProps.localeText;

// Date pickers follow the app language: Spanish types and shows DD/MM/YYYY and translates
// the picker buttons ("Cancelar", "Aceptar"…), English keeps MUI's defaults.
const DateLocalizationProvider = ({ children }) => {
  const locale = useLanguage()?.locale === "en" ? "en" : "es";

  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale={locale}
      localeText={locale === "es" ? SPANISH_LOCALE_TEXT : undefined}
    >
      {children}
    </LocalizationProvider>
  );
};

export default DateLocalizationProvider;
